import { defineMessages } from 'react-intl-next';

export const i18n: {
	content: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluenceFilterPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluenceFilterLabelSelected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluenceFilterLabelUnselected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	content: {
		id: 'search-page.filters.names.content',
		defaultMessage: 'Content under',
		description: 'Label for filtering by content under a confluence page',
	},
	confluenceFilterPlaceholder: {
		id: 'search-page.confluence.filter.content.placeholder',
		defaultMessage: 'Find content',
		description: 'Placeholder for content filter search input',
	},
	confluenceFilterLabelSelected: {
		id: 'search-page.confluence.filter.content.selected',
		defaultMessage: 'Selected',
		description: 'Confluence filter content selected',
	},
	confluenceFilterLabelUnselected: {
		id: 'search-page.confluence.filter.content.unselected',
		defaultMessage: 'Suggested',
		description: 'Confluence filter content unselected',
	},
});
